import { render, staticRenderFns } from "./UserAssignmentHistory.vue?vue&type=template&id=edf01fa6&scoped=true&"
import script from "./UserAssignmentHistory.vue?vue&type=script&lang=js&"
export * from "./UserAssignmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignmentHistory.vue?vue&type=style&index=0&id=edf01fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf01fa6",
  null
  
)

export default component.exports